import example from './src/blaze-plugins/example';

export default function buildConfig(config) {
  config.plugins.set(example, {});
  return config;
}
